// Prepare assistant text for TTS. Strips widget markup, markdown markers and
// decorative symbols so the voice never reads noise like "зірочка" or markdown.
// Letters (uk/ru), digits, prices and normal punctuation are preserved.
export function sanitizeTextForSpeech(text) {
    if (text == null) return ''
    let out = String(text)

    // 1. Drop the order-proposal block entirely (it is JSON, never spoken).
    out = out.replace(/\[\[ORDER:[\s\S]*?\]\]/g, ' ')

    // 1b. Chips separated only by glue (markdown markers / whitespace / light
    //     punctuation) form a list — join with a comma so TTS pauses between
    //     items instead of reading them run-on. Glue containing real words
    //     (e.g. "[[A]] або [[B]]") is left untouched.
    out = out.replace(/\]\](?:[\s*_`•·,;.\-–—])*\[\[/g, ']], [[')

    // 2. Unwrap chip markup: [[Молоко]] -> Молоко
    out = out.replace(/\[\[(.+?)\]\]/gs, '$1')

    // 3. Drop bullet markers at the start of lines: "* ", "- ", "• ", "– "
    out = out.replace(/^[ \t]*[*•·‣▪►\-–—]+[ \t]+/gm, '')

    // 4. Remove inline markdown emphasis / code markers: * _ ` ~
    out = out.replace(/[*_`~]/g, '')

    // 5. Remove decorative emoji / pictographs / symbols that must not be read
    //    (e.g. ✨ ⭐ ★ ▪) plus invisible joiners / variation selectors.
    try {
        out = out.replace(/[\p{Extended_Pictographic}\p{So}\p{Default_Ignorable_Code_Point}]/gu, ' ')
    } catch { /* Unicode property escapes unsupported on a very old engine */ }
    out = out.replace(/[•·‣▪◦]/g, ' ')

    // 6. Collapse whitespace.
    out = out.replace(/\s+/g, ' ').trim()

    return out
}

export default sanitizeTextForSpeech
